import React, { Component } from 'react';
import './style.css'
import { Nav, NavItem, NavLink } from 'reactstrap';
import Logo from './../../assets/logo.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faSitemap, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';

class Sidebar extends Component {
    state = { 
        isOpen: true,
        sidebarStyle: 'bg-sidebar'
    }

    toggle=()=>{
        this.setState({sidebarStyle: ' bg-sidebar-deact'})
    }
    
    render() { 
        return ( 
            <div className={this.state.sidebarStyle}>
                <div className='content-sidebar'>
                    <div className='logo-sidebar mb-2'>
                        <img src={Logo} alt="" className='logo-sidebar'/>
                    </div>
                    <div className='nav-sidebar mt-5'>
                        <div className='col-3 rounded-icon-bg' onClick={this.toggle}>
                            <FontAwesomeIcon icon={faAngleRight} size='2x' color='#fa26a0'/>
                        </div>
                        <Nav className='d-flex flex-column auto-overflow'>
                            <NavItem>
                                <NavLink href="#" className='txt-white bg-blue-sidebar d-flex mb-2'>
                                    <div className='col-3'>
                                        <FontAwesomeIcon icon={faAddressCard} size='2x' color='#fa26a0'/>
                                    </div>
                                    <div className='col-8'>
                                        <Link to='/' className='sidebar'>
                                            <span className='ml-3'><b>Students</b></span>
                                        </Link>
                                    </div>
                                </NavLink>
                                <NavLink href="#" className='txt-white bg-blue-sidebar d-flex'>
                                    <div className='col-3'>
                                        <FontAwesomeIcon icon={faSitemap} size='2x' color='#fa26a0'/>
                                    </div>
                                    <div className='col-8'>
                                        <Link to='/staff' className='sidebar'>
                                            <span className='ml-3'><b>Staffs</b></span>
                                        </Link>
                                    </div>
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div>
                </div>
            </div>
         );
    }
}
 
export default Sidebar;